module.exports = "<div class=\"route-popup\">\r\n    <create-edit-popup options=\"options\"></create-edit-popup>\r\n</div>\r\n"